
import styled from "styled-components";
interface StatusProps {
  status: string;
}



export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #f3f4f6;
`;


export const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 12px;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  background-color: #fff;
  padding: 16px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.2rem;
  outline: none;
  transition: 0.2s;

  &:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
  }
`;

export const SelectInput = styled.select`
  padding: 12px;
  font-size: 1.2rem;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  cursor: pointer;
`;

export const ContentService = styled.div`
  width: 100%;
  overflow-x: auto; /* SCROLL HORIZONTAL */
`;

export const ContentServiceHeader = styled.div`
  min-width: 700px; /* importante pro scroll */
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px 10px 0 0;
  padding: 14px 20px;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  font-size: 1.2rem;
  font-weight: 600;
  color: #374151;
`;

export const ContentServiceContent = styled.div`
  min-width: 700px; /* acompanha header */
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-top: none;
  padding: 14px 20px;
  font-size: 1rem;

  display: grid;
  grid-template-columns: repeat(8, 1fr);
  align-items: center;
  gap: 10px;

  transition: 0.2s;

  &:hover {
    background-color: #f9fafb;
  }
`;

export const Modelo = styled.span``;
export const Placa = styled.span``;
export const Tipo = styled.span``;
export const Entrada = styled.span``;
export const Saida = styled.span``;
export const Valor = styled.span``;
export const Cliente = styled.span``;


export const Status = styled.span<StatusProps>`
  font-weight: 600;
  color: ${({ status }) =>
    status === "Concluído"
      ? "#16a34a"
      : status === "Em Andamento"
      ? "#f59e0b"
      : "#ef4444"};
`;

export const Acoes = styled.div`
  display: flex;
  gap: 8px;

  svg {
    cursor: pointer;
    transition: 0.2s;
  }

  svg:hover {
    transform: scale(1.2);
  }
`;